/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestProgressionMilestone
 */
export interface QuestProgressionMilestone {
    /**
     * 
     * @type {boolean}
     * @memberof QuestProgressionMilestone
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    claimedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    sessionAmount?: number;
}

export function QuestProgressionMilestoneFromJSON(json: any): QuestProgressionMilestone {
    return QuestProgressionMilestoneFromJSONTyped(json, false);
}

export function QuestProgressionMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestProgressionMilestone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isComplete': json['isComplete'],
        'claimedAt': !exists(json, 'claimedAt') ? undefined : json['claimedAt'],
        'amount': json['amount'],
        'sessionAmount': !exists(json, 'sessionAmount') ? undefined : json['sessionAmount'],
    };
}

export function QuestProgressionMilestoneToJSON(value?: QuestProgressionMilestone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isComplete': value.isComplete,
        'claimedAt': value.claimedAt,
        'amount': value.amount,
        'sessionAmount': value.sessionAmount,
    };
}


